import { type ColumnConfig, type DualAxesConfig } from '@ant-design/plots'
import dayjs from 'dayjs'

import {
  type DayjsRange,
  type StatisticsData,
  type StatisticsRangePreset,
  type StatisticsTimeRange,
} from './types/common'

export const STATISTICS_RANGE_PRESETS: Record<
  StatisticsRangePreset,
  DayjsRange
> = {
  day: {
    start: dayjs().startOf('day'),
    end: dayjs().endOf('day'),
  },
  week: {
    start: dayjs().startOf('week'),
    end: dayjs().endOf('week'),
  },
  month: {
    start: dayjs().startOf('month'),
    end: dayjs().endOf('month'),
  },
  allTime: { allTime: true },
} as const

export const STATISTICS_RANGE_FORMATS: Record<StatisticsTimeRange, string> = {
  day: 'HH:mm',
  month: 'DD-MM-YYYY',
  year: 'MM-YYYY',
}

export const COMMON_CHARTS_CONFIG: ColumnConfig | DualAxesConfig = {
  autoFit: true,
  xField: 'date',
  yField: 'data',
  legend: false,
  interaction: {
    tooltip: {
      css: {
        '.g2-tooltip': {
          background: '#fff',
          'border-radius': '8px',
          'box-shadow': '0px 4px 8px rgba(0, 0, 0, 0.5)',
          width: 'auto !important',
          'max-width': 'auto !important',
          'white-space': 'nowrap',
          padding: '8px 12px',
          'box-sizing': 'border-box',
        },
        '.g2-tooltip-title': {
          'text-align': 'center',
        },
      },
    },
  },
  tooltip: {
    title: (datum: StatisticsData) => ({
      value: `<span style="font-size: 14px">
      <span style="font-weight: 600; color: rgba(0,0,0,1)">${datum.data}</span>
      &nbsp;
      <span style="font-weight: 400; color: rgba(0,0,0,0.5)">${datum.date}</span>
</span>`,
      custom: '...',
    }),

    items: false,
  },
}
